export default "__VITE_ASSET__6e7dcc32__"